import React from 'react';
import Dialog from "../../../../../components/ui/Dialog/Dialog";
import AssignShipment from "./AssignShipment";
import {useTranslation} from "react-i18next";

type AssignShipmentDialogProps = {
    id: string | Array<string>;
    show: boolean;
    setShow:  React.Dispatch<React.SetStateAction<boolean>>;
}
const AssignShipmentDialog: React.FC<AssignShipmentDialogProps> = ({
                                                                       id,
                                                                       show,
                                                                       setShow
                                                                   }) => {
    const {t} = useTranslation();

    return (
        <Dialog id={'assign-shipment-dialog'}
                show={show}
                setShow={setShow}
                width={'650px'}
                title={t("shared.btn.assign-order")}>
            <AssignShipment id={id} close={() => setShow(prev => !prev)}/>
        </Dialog>
    );
};

export default AssignShipmentDialog;